const en = {
    heloo: "Hello",
    change_language: "Change Language",
    home: "Home",
    create_augmented_reality: "Create Augmented Reality",
    orders: "Orders",
    payments: "Payments",
    camera: "Camera",
    constructed_augmented: "Constructed Augmented Realities",
    total_payments: "Total Payments",
    number_views_files: "Number of Views for All Files",
    augmented_gallery: "Augmented Reality Gallery",
    view_all: "View All",
    gallery_videos: "Gallery Videos and News",
    number_of_visits: "Number of Visits",
    production_date: "Production Date",
    video_not_found: "Video Not Found",
    profile: "Profile",
    edit_profile: "Edit Profile",
    sign_out: "Sign Out",
    Your_profile_is_inactive: "Your Profile is Inactive",
    fill_the_box_below: "Fill the Box Below",
    augmented_reality_code: "Augmented Reality Code",
    registration: "Registration",
    link: "Link",
    financial_reports: "Financial Reports",
    search: "Search",
    search_in: "Search in...",
    Paid: 'Paid',
    Repayment: "Repayment",
    free: "Free",
    yearly: "Yearly",
    create_two_images: "Create Two Images",
    ten_visits_per_year: "10 Visits Per Year",
    business_facilities: "Business Facilities",
    selection: "Selection",
    business: "Business",
    toman: "$",
    no_visit_limit: "No Visit Limit per Year ",
    extendable: "Extendable Annually",
    ability_multiple_images: "Ability to Add Multiple Images (at a Lower Cost)",
    hyperlink: "Hyperlinks (Website, Contact, Instagram, Guide)",
    personal: "Personal",
    visits_per_year_360: "360 Visits Per Year",
    create_an_image: "Create an Image",
    the_image_below_is_5mb: "The Image Below is 5MB or Less",
    the_video_below_is_50mb: "The Video Below is 50MB or Less",
    your_photo: "Your Photo",
    tip: "Tip",
    your_video: "Your Video",
    names: "Names",
    more_settings: "+ More Settings",
    fewer_settings: "- Fewer Settings",
    price: "Price",
    send: "Send",
    uploading: "Uploading and Converting Video, this process may take a few minutes. Please wait.",
    site_link: "Site Link",
    help_site: 'Help Site',
    phone_number: "Phone Number",
    your_qr_code: "Your QR Code",
    scan_qr_code: "You can scan the QR code below and download or copy the URL",
    dates: "Dates",
    visit: "Visit",
    copy: "Copy",
    download_qr_code: "Download QR Code",
    successful_payment: "Successful Payment",
    thank_you_for_payment: "Thank you for completing your secure online payment",
    are_you_sure_to_exit: "Are you sure you want to exit?",
    yes_im_sure: "Yes, I'm Sure",
    no_thanks: "No, Thanks",
    cancel_augmented_reality: "Cancel Augmented Reality",
    download: "Download",
    please_enter_augmented: "Please Enter Augmented Reality ID",
    id: "ID",
    please_wait: "Please Wait",
    instagram_username: "Instagram Username (without @ symbol)",
    create_an_account: "Create an Account for AR Live",
    complete_the_form: "Complete the Form to Create a User Account",
    form_registration: "Name and Surname (Company Name)",
    phone: "Mobile Number",
    select_the_country: "Select the Country",
    user_name: "Username",
    please_use_english: "Please use only English letters",
    password: "Password",
    password_must_be_six_digits: "Password should be more than 6 characters and a combination of numbers and letters",
    show_password: "Show Password",
    repeat_the_password: "Repeat Password",
    select_the_language: "Change Language",
    register: "Register",
    register_the_code: "Register the Code",
    enter_code: "Enter the Code",
    sent: "Sent",
    code_for_the_number: "Code for Your Number",
    have_you_registered: "Have You Registered?",
    log_in: "Log In",
    create_a_new_user_account: "Create a New User Account",
    create_password_to_six: "Create a Password to Six Digits",
    password_not_the_same: "Passwords Are Not the Same",
    You_currently_with_account: "You are currently logged in with your account",
    verification_code_is_incorrect: "Incorrect verification code",
    registration_was_successful: "Registration was successful",
    fill: "Fill",
    login_to_account: "Login to account",
    login_via_password: "Login via password",
    log_via_sms: "Login via SMS",
    form_nameValidation: "Mobile number or username",
    send_code: "Send code",
    you_are_not_authenticated: "You are not authenticated yet",
    not_registered: "Not registered?",
    passwordValidation: "Password",
    code_successfully_verified: "Code successfully verified",
    please_fill_name_validation: "Please fill in the name",
    please_fill_picture_validation: "Please fill in the picture",
    you_cannot_multiple_photos_validation: "You cannot define multiple photos",
    do_not_duplicate_videos_validation: "Do not add duplicate videos",
    do_not_duplicate_photos_validation: "Do not add duplicate photos",
    video_more_50_MB_validation: "Video is more than 50 MB",
    image_size_5mb_validation: 'Image size is more than 5 MB',
    fill_in_video_validation: "Fill in the video",
    fill_in_image_validation: "Fill in the image",
    your_video_photos: "Your videos and photos",
    image: "Image",
    video: "Video",
    payment_was_successful: 'Payment was successful',
    go_to_home_page: "Go to homepage",
    product_id: "Product ID",
    return_main_page: "Return to main page",
    difficulty_paying: "Difficulty paying",
    payment_not_successful: "Payment not successful",
    make_the_operation: "To complete the operation, perform the payment again",
    return_the_page: "Return to homepage",
    you_not_access: "You do not have access",
    qr_code: "QR code",
    link_was_copied: "Link was copied",
    oreders: "Orders",
    payment_message: "Payment message",
    payment_failed: "Payment failed",
    payment_code: "Payment ID",
    does_not_exist: "Does not exist",
    card_number: "Card number",
    wait: "Please wait",
    mission_was_successful: "mission accomplished",
    Upload_a_new_video: "Upload a new video",
    Delete_augmented_reality: "Delete augmented reality",
    Are_you_sure_about_removing_augmented_reality: "Are you sure about removing augmented reality?",
    Are_you_sure_about_canceling_augmented_reality: "Are you sure about canceling augmented reality?",
    yes: "yes",
    no: "no",
    edit: "edit",
    add: "Add",
    convertVideo: "Converting video, please wait",
    no_augmented: "No augmented reality found",


    // لم يتم العثور على واقع معزز.
}



export default en;